<div class="collapsy">
  <div class="main-container">
    <div class="search-input">
      <ion-icon name="search-outline"></ion-icon>
      <input
        (input)="onInputChange($event.target.value)"
        [(ngModel)]="searchText"
        class="input"
        placeholder="Search"
        autocapitalize="off"
        autocorrect="off"
        spellcheck="false"
      />
      <ion-icon
        slot="end"
        (click)="clearSearch()"
        name="close-circle"
      ></ion-icon>
    </div>
  </div>

  <div class="filterWrapper">
    <div class="filterItem">
      <ion-label class="filterLabel">By State</ion-label>
      <ion-select
        [disabled]="!items.length"
        lines="none"
        interface="popover"
        class="filterSelect"
        [ngModel]="selectedLvl0"
        (ionChange)="updateLevel0($event.detail.value)"
        placeholder="Select State"
      >
        <ion-select-option
          style="border: 0px"
          lines="none"
          class="customSelectItem"
          *ngFor="let item of eligibleStates"
          [value]="item.value"
        >
          {{item.label}}</ion-select-option
        >
      </ion-select>
    </div>

    <div (click)="checkForInvalidCity()" class="filterItem">
      <ion-label class="filterLabel">By City</ion-label>
      <ion-select
        [disabled]="disableCitiesSelect"
        lines="none"
        interface="popover"
        class="filterSelect"
        placeholder="Select City"
        [ngModel]="selectedLvl1"
        (ionChange)="updateLevel1($event.detail.value)"
      >
        <ion-select-option
          lines="none"
          *ngFor="let item of getLevel1()?.data"
          [value]="item.value"
          >{{item.label}}
        </ion-select-option>
      </ion-select>
    </div>
  </div>

  <div class="filterWrapper">
    <div class="filterItem">
      <ion-label class="filterLabel">{{getRecentActivityFilterLabel()}}</ion-label>
      <ion-select
        interface="popover"
        class="filterSelect"
        placeholder="Any Time"
        (ionChange)="recentlyActiveSelectionChange()"
        [(ngModel)]="recentlyActiveOption"
      >
        <ion-select-option value="all">Any Time</ion-select-option>
        <ion-select-option value="30">30 Days</ion-select-option>
        <ion-select-option value="90">90 Days</ion-select-option>
        <ion-select-option value="365">Last Year</ion-select-option>
      </ion-select>
    </div>

    <div class="filterItem">
      <ion-button
        id="mainResetButton"
        (click)="reset()"
        fill="outline"
        color="primary"
      >
        <ion-label>Reset Filter</ion-label>
      </ion-button>
    </div>
  </div>
</div>

<div *ngIf="hits.length !== 0" class="hits">
  <div class="hit" *ngFor="let hit of hits">
    <!-- 
      `childComponent` is used to render the passed in component. `context` defines the available variables to be binded
      using the `let-...` syntax. Using the `$implicit` token set the default value to be binded, in this case, the current hit
    -->
    <ng-container
      *ngTemplateOutlet="childComponent; context: { $implicit: hit }"
    ></ng-container>
  </div>
</div>

<div *ngIf="displayNoResultsLabel()" class="no-results-label">
  {{ noResultsMessage }}
</div>

<div *ngIf="displaySeeMoreButton()" class="ion-text-center">
  <ion-button color="primary" (click)="queryNextPage()">
    <ion-label>See More</ion-label>
  </ion-button>
</div>
